function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

var OpacityDisabled = "0.4";
var TokenOpacity = {
	OpacityDisabled: OpacityDisabled
};

var BorderThin = "1px solid";
var BorderMedium = "2px solid";
var BorderOutline = "2px";
var BorderSolid = "solid";
var BorderRadiusDefault = "8px";
var BorderRadiusCompact = "7px";
var BorderRadiusSmall = "6px";
var BorderRadiusFull = "50%";
var TokenBorders = {
	BorderThin: BorderThin,
	BorderMedium: BorderMedium,
	BorderOutline: BorderOutline,
	BorderSolid: BorderSolid,
	BorderRadiusDefault: BorderRadiusDefault,
	BorderRadiusCompact: BorderRadiusCompact,
	BorderRadiusSmall: BorderRadiusSmall,
	BorderRadiusFull: BorderRadiusFull
};

var ShadowPlus1 = "0 2px 4px rgba(22, 25, 25, 0.2)";
var ShadowPlus2 = "0 4px 8px rgba(22, 25, 25, 0.4)";
var ShadowMinus1 = "0 1px 3px rgba(22, 25, 25, 0.2)";
var ShadowBottom1 = "0 1px -2px rgba(22, 25, 25, 0.2)";
var ShadowLeft1 = "2px 0 4px rgba(22, 25, 25, 0.2)";
var ShadowRight1 = "-2px 0 4px rgba(22, 25, 25, 0.2)";
var TokenShadows = {
	ShadowPlus1: ShadowPlus1,
	ShadowPlus2: ShadowPlus2,
	ShadowMinus1: ShadowMinus1,
	ShadowBottom1: ShadowBottom1,
	ShadowLeft1: ShadowLeft1,
	ShadowRight1: ShadowRight1
};

var ColorChartCategory1$1 = "#0092cc";
var ColorChartCategory2$1 = "#005172";
var ColorChartCategory3$1 = "#be47b5";
var ColorChartCategory4$1 = "#ba4589";
var ColorChartCategory5$1 = "#006d75";
var ColorChartCategory6$1 = "#089e94";
var ColorChartCategory7$1 = "#632a6e";
var ColorChartCategory8$1 = "#bf4860";
var ColorChartCategory1Alpha1$1 = "rgba(0, 146, 204, 0.1)";
var ColorChartCategory1Alpha2$1 = "rgba(0, 146, 204, 0.2)";
var ColorChartCategory1Alpha4$1 = "rgba(0, 146, 204, 0.4)";
var ColorChartCategory2Alpha1$1 = "rgba(0, 81, 114, 0.1)";
var ColorChartCategory2Alpha2$1 = "rgba(0, 81, 114, 0.2)";
var ColorChartCategory2Alpha4$1 = "rgba(0, 81, 114, 0.4)";
var ColorChartCategory3Alpha1$1 = "rgba(190, 71, 181, 0.1)";
var ColorChartCategory3Alpha2$1 = "rgba(190, 71, 181, 0.2)";
var ColorChartCategory3Alpha4$1 = "rgba(190, 71, 181, 0.4)";
var ColorChartCategory4Alpha1$1 = "rgba(186, 69, 137, 0.1)";
var ColorChartCategory4Alpha2$1 = "rgba(186, 69, 137, 0.2)";
var ColorChartCategory4Alpha4$1 = "rgba(186, 69, 137, 0.4)";
var ColorChartCategory5Alpha1$1 = "rgba(0, 109, 117, 0.1)";
var ColorChartCategory5Alpha2$1 = "rgba(0, 109, 117, 0.2)";
var ColorChartCategory5Alpha4$1 = "rgba(0, 109, 117, 0.4)";
var ColorChartCategory6Alpha1$1 = "rgba(8, 158, 148, 0.1)";
var ColorChartCategory6Alpha2$1 = "rgba(8, 158, 148, 0.2)";
var ColorChartCategory6Alpha4$1 = "rgba(8, 158, 148, 0.4)";
var ColorChartCategory7Alpha1$1 = "rgba(99, 42, 110, 0.1)";
var ColorChartCategory7Alpha2$1 = "rgba(99, 42, 110, 0.2)";
var ColorChartCategory7Alpha4$1 = "rgba(99, 42, 110, 0.4)";
var ColorChartCategory8Alpha1$1 = "rgba(191, 72, 96, 0.1)";
var ColorChartCategory8Alpha2$1 = "rgba(191, 72, 96, 0.2)";
var ColorChartCategory8Alpha4$1 = "rgba(191, 72, 96, 0.4)";
var ColorChartUncategory1$1 = "#6b6d6f";
var ColorChartUncategory2$1 = "#161919";
var ColorChartUncategory3$1 = "#cbcdce";
var TokenChartColors = {
	ColorChartCategory1: ColorChartCategory1$1,
	ColorChartCategory2: ColorChartCategory2$1,
	ColorChartCategory3: ColorChartCategory3$1,
	ColorChartCategory4: ColorChartCategory4$1,
	ColorChartCategory5: ColorChartCategory5$1,
	ColorChartCategory6: ColorChartCategory6$1,
	ColorChartCategory7: ColorChartCategory7$1,
	ColorChartCategory8: ColorChartCategory8$1,
	ColorChartCategory1Alpha1: ColorChartCategory1Alpha1$1,
	ColorChartCategory1Alpha2: ColorChartCategory1Alpha2$1,
	ColorChartCategory1Alpha4: ColorChartCategory1Alpha4$1,
	ColorChartCategory2Alpha1: ColorChartCategory2Alpha1$1,
	ColorChartCategory2Alpha2: ColorChartCategory2Alpha2$1,
	ColorChartCategory2Alpha4: ColorChartCategory2Alpha4$1,
	ColorChartCategory3Alpha1: ColorChartCategory3Alpha1$1,
	ColorChartCategory3Alpha2: ColorChartCategory3Alpha2$1,
	ColorChartCategory3Alpha4: ColorChartCategory3Alpha4$1,
	ColorChartCategory4Alpha1: ColorChartCategory4Alpha1$1,
	ColorChartCategory4Alpha2: ColorChartCategory4Alpha2$1,
	ColorChartCategory4Alpha4: ColorChartCategory4Alpha4$1,
	ColorChartCategory5Alpha1: ColorChartCategory5Alpha1$1,
	ColorChartCategory5Alpha2: ColorChartCategory5Alpha2$1,
	ColorChartCategory5Alpha4: ColorChartCategory5Alpha4$1,
	ColorChartCategory6Alpha1: ColorChartCategory6Alpha1$1,
	ColorChartCategory6Alpha2: ColorChartCategory6Alpha2$1,
	ColorChartCategory6Alpha4: ColorChartCategory6Alpha4$1,
	ColorChartCategory7Alpha1: ColorChartCategory7Alpha1$1,
	ColorChartCategory7Alpha2: ColorChartCategory7Alpha2$1,
	ColorChartCategory7Alpha4: ColorChartCategory7Alpha4$1,
	ColorChartCategory8Alpha1: ColorChartCategory8Alpha1$1,
	ColorChartCategory8Alpha2: ColorChartCategory8Alpha2$1,
	ColorChartCategory8Alpha4: ColorChartCategory8Alpha4$1,
	ColorChartUncategory1: ColorChartUncategory1$1,
	ColorChartUncategory2: ColorChartUncategory2$1,
	ColorChartUncategory3: ColorChartUncategory3$1
};

var ColorBackgroundWhite = "#ffffff";
var ColorBackgroundWhiteAlpha1 = "rgba(255, 255, 255, 0.1)";
var ColorBackgroundWhiteAlpha2 = "rgba(255, 255, 255, 0.2)";
var ColorBackgroundGray = "#f6f7f8";
var ColorBackgroundGrayAlpha4 = "rgba(246, 247, 248, 0.4)";
var ColorBackgroundNavPrimary = "#003957";
var ColorBackgroundButtonPrimary = "#1a80a1";
var ColorBackgroundButtonPrimaryHover = "#05485d";
var ColorBackgroundButtonPrimaryDisabled = "#a4cdda";
var ColorBackgroundButtonSecondary = "#1381a2";
var ColorBackgroundButtonSecondaryHover = "#05485d";
var ColorBackgroundButtonSecondaryDisabled = "#acd1de";
var ColorBackgroundButtonTertiary = "#1381a2";
var ColorBackgroundButtonTertiaryHover = "#05485d";
var ColorBackgroundButtonTertiaryDisabled = "#acd1de";
var ColorBackgroundRadiobuttonDisabled = "#fbf8f8";
var ColorBackgroundCheckboxDisabled = "#ffffff";
var ColorBackgroundInputDisabled = "#f4f6f6";
var ColorBackgroundDropdownHover = "#e5e7e7";
var ColorBackgroundDropdownListHover = "#efefef";
var ColorBackgroundModalTransparency = "rgba(245, 250, 252, 0.9)";
var ColorChartCategory1 = "#0092cc";
var ColorChartCategory2 = "#005172";
var ColorChartCategory3 = "#be47b5";
var ColorChartCategory4 = "#ba4589";
var ColorChartCategory5 = "#006d75";
var ColorChartCategory6 = "#089e94";
var ColorChartCategory7 = "#632a6e";
var ColorChartCategory8 = "#bf4860";
var ColorChartCategory1Alpha1 = "rgba(0, 146, 204, 0.1)";
var ColorChartCategory1Alpha2 = "rgba(0, 146, 204, 0.2)";
var ColorChartCategory1Alpha4 = "rgba(0, 146, 204, 0.4)";
var ColorChartCategory2Alpha1 = "rgba(0, 81, 114, 0.1)";
var ColorChartCategory2Alpha2 = "rgba(0, 81, 114, 0.2)";
var ColorChartCategory2Alpha4 = "rgba(0, 81, 114, 0.4)";
var ColorChartCategory3Alpha1 = "rgba(190, 71, 181, 0.1)";
var ColorChartCategory3Alpha2 = "rgba(190, 71, 181, 0.2)";
var ColorChartCategory3Alpha4 = "rgba(190, 71, 181, 0.4)";
var ColorChartCategory4Alpha1 = "rgba(186, 69, 137, 0.1)";
var ColorChartCategory4Alpha2 = "rgba(186, 69, 137, 0.2)";
var ColorChartCategory4Alpha4 = "rgba(186, 69, 137, 0.4)";
var ColorChartCategory5Alpha1 = "rgba(0, 109, 117, 0.1)";
var ColorChartCategory5Alpha2 = "rgba(0, 109, 117, 0.2)";
var ColorChartCategory5Alpha4 = "rgba(0, 109, 117, 0.4)";
var ColorChartCategory6Alpha1 = "rgba(8, 158, 148, 0.1)";
var ColorChartCategory6Alpha2 = "rgba(8, 158, 148, 0.2)";
var ColorChartCategory6Alpha4 = "rgba(8, 158, 148, 0.4)";
var ColorChartCategory7Alpha1 = "rgba(99, 42, 110, 0.1)";
var ColorChartCategory7Alpha2 = "rgba(99, 42, 110, 0.2)";
var ColorChartCategory7Alpha4 = "rgba(99, 42, 110, 0.4)";
var ColorChartCategory8Alpha1 = "rgba(191, 72, 96, 0.1)";
var ColorChartCategory8Alpha2 = "rgba(191, 72, 96, 0.2)";
var ColorChartCategory8Alpha4 = "rgba(191, 72, 96, 0.4)";
var ColorChartUncategory1 = "#6b6d6f";
var ColorChartUncategory2 = "#161919";
var ColorChartUncategory3 = "#cbcdce";
var ColorGrayPrimary = "#161919";
var ColorGrayPrimaryAlpha1 = "rgba(22, 25, 25, 0.1)";
var ColorGrayPrimaryAlpha2 = "rgba(22, 25, 25, 0.2)";
var ColorGrayPrimaryAlpha4 = "rgba(22, 25, 25, 0.4)";
var ColorGraySecondary = "#6b6d6f";
var ColorGraySecondaryAlpha1 = "rgba(107, 109, 111, 0.1)";
var ColorGraySecondaryAlpha2 = "rgba(107, 109, 111, 0.2)";
var ColorGraySecondaryAlpha4 = "rgba(107, 109, 111, 0.4)";
var ColorGrayIncidental = "#cbcdce";
var ColorGrayIncidentalAlpha1 = "rgba(203, 205, 206, 0.1)";
var ColorGrayIncidentalAlpha2 = "rgba(203, 205, 206, 0.2)";
var ColorGrayIncidentalAlpha4 = "rgba(203, 205, 206, 0.4)";
var ColorNotificationInfo = "#005172";
var ColorNotificationSuccess = "#007132";
var ColorNotificationSuccessAlpha1 = "rgba(0, 113, 50, 0.1)";
var ColorNotificationSuccessAlpha4 = "rgba(0, 113, 50, 0.4)";
var ColorNotificationWarning = "#ba4700";
var ColorNotificationWarningAlpha1 = "rgba(186, 71, 0, 0.1)";
var ColorNotificationWarningAlpha4 = "rgba(186, 71, 0, 0.4)";
var ColorNotificationError = "#d21e17";
var ColorNotificationErrorAlpha1 = "rgba(210, 30, 23, 0.1)";
var ColorNotificationErrorAlpha4 = "rgba(210, 30, 23, 0.4)";
var ColorPrimaryBlue = "#005172";
var ColorPrimaryBlueAlpha1 = "rgba(0, 81, 114, 0.1)";
var ColorPrimaryBlueAlpha4 = "rgba(0, 81, 114, 0.4)";
var ColorPrimaryBlueInteractive = "#0078a7";
var ColorPrimaryBlueInteractiveAlpha1 = "rgba(0, 120, 167, 0.1)";
var ColorPrimaryBlueInteractiveAlpha2 = "rgba(0, 120, 167, 0.2)";
var ColorPrimaryBlueInteractiveAlpha4 = "rgba(0, 120, 167, 0.4)";
var ColorScaleLow = "#007132";
var ColorScaleMild = "#57a11c";
var ColorScaleModerate = "#f4bb14";
var ColorScaleElevated = "#e66b0e";
var ColorScaleHigh = "#d21e17";
var ColorScaleSevere = "#95120e";
var ColorSecondaryBlueLight = "#0092cc";
var ColorSecondaryBlueBrandLight = "#3095b4";
var ColorSecondaryPurpleLight = "#be47b5";
var ColorSecondaryPurpleLightAlpha1 = "rgba(190, 71, 181, 0.1)";
var ColorSecondaryPurpleDark = "#632a6e";
var ColorSecondaryPurpleDarkAlpha1 = "rgba(99, 42, 110, 0.1)";
var ColorSecondaryVioletLight = "#ba4589";
var ColorSecondaryVioletDark = "#802d5e";
var ColorSecondaryVioletDarkAlpha1 = "rgba(128, 45, 94, 0.1)";
var ColorSecondaryTealLight = "#089e94";
var ColorSecondaryTealDark = "#006d75";
var ColorSecondaryTealDarkAlpha1 = "rgba(0, 109, 117, 0.1)";
var ColorSecondaryPinkLight = "#bf4860";
var ColorSecondaryPinkDark = "#9b3054";
var ColorSecondaryPinkDarkAlpha1 = "rgba(155, 48, 84, 0.1)";
var TokenColors = {
	ColorBackgroundWhite: ColorBackgroundWhite,
	ColorBackgroundWhiteAlpha1: ColorBackgroundWhiteAlpha1,
	ColorBackgroundWhiteAlpha2: ColorBackgroundWhiteAlpha2,
	ColorBackgroundGray: ColorBackgroundGray,
	ColorBackgroundGrayAlpha4: ColorBackgroundGrayAlpha4,
	ColorBackgroundNavPrimary: ColorBackgroundNavPrimary,
	ColorBackgroundButtonPrimary: ColorBackgroundButtonPrimary,
	ColorBackgroundButtonPrimaryHover: ColorBackgroundButtonPrimaryHover,
	ColorBackgroundButtonPrimaryDisabled: ColorBackgroundButtonPrimaryDisabled,
	ColorBackgroundButtonSecondary: ColorBackgroundButtonSecondary,
	ColorBackgroundButtonSecondaryHover: ColorBackgroundButtonSecondaryHover,
	ColorBackgroundButtonSecondaryDisabled: ColorBackgroundButtonSecondaryDisabled,
	ColorBackgroundButtonTertiary: ColorBackgroundButtonTertiary,
	ColorBackgroundButtonTertiaryHover: ColorBackgroundButtonTertiaryHover,
	ColorBackgroundButtonTertiaryDisabled: ColorBackgroundButtonTertiaryDisabled,
	ColorBackgroundRadiobuttonDisabled: ColorBackgroundRadiobuttonDisabled,
	ColorBackgroundCheckboxDisabled: ColorBackgroundCheckboxDisabled,
	ColorBackgroundInputDisabled: ColorBackgroundInputDisabled,
	ColorBackgroundDropdownHover: ColorBackgroundDropdownHover,
	ColorBackgroundDropdownListHover: ColorBackgroundDropdownListHover,
	ColorBackgroundModalTransparency: ColorBackgroundModalTransparency,
	ColorChartCategory1: ColorChartCategory1,
	ColorChartCategory2: ColorChartCategory2,
	ColorChartCategory3: ColorChartCategory3,
	ColorChartCategory4: ColorChartCategory4,
	ColorChartCategory5: ColorChartCategory5,
	ColorChartCategory6: ColorChartCategory6,
	ColorChartCategory7: ColorChartCategory7,
	ColorChartCategory8: ColorChartCategory8,
	ColorChartCategory1Alpha1: ColorChartCategory1Alpha1,
	ColorChartCategory1Alpha2: ColorChartCategory1Alpha2,
	ColorChartCategory1Alpha4: ColorChartCategory1Alpha4,
	ColorChartCategory2Alpha1: ColorChartCategory2Alpha1,
	ColorChartCategory2Alpha2: ColorChartCategory2Alpha2,
	ColorChartCategory2Alpha4: ColorChartCategory2Alpha4,
	ColorChartCategory3Alpha1: ColorChartCategory3Alpha1,
	ColorChartCategory3Alpha2: ColorChartCategory3Alpha2,
	ColorChartCategory3Alpha4: ColorChartCategory3Alpha4,
	ColorChartCategory4Alpha1: ColorChartCategory4Alpha1,
	ColorChartCategory4Alpha2: ColorChartCategory4Alpha2,
	ColorChartCategory4Alpha4: ColorChartCategory4Alpha4,
	ColorChartCategory5Alpha1: ColorChartCategory5Alpha1,
	ColorChartCategory5Alpha2: ColorChartCategory5Alpha2,
	ColorChartCategory5Alpha4: ColorChartCategory5Alpha4,
	ColorChartCategory6Alpha1: ColorChartCategory6Alpha1,
	ColorChartCategory6Alpha2: ColorChartCategory6Alpha2,
	ColorChartCategory6Alpha4: ColorChartCategory6Alpha4,
	ColorChartCategory7Alpha1: ColorChartCategory7Alpha1,
	ColorChartCategory7Alpha2: ColorChartCategory7Alpha2,
	ColorChartCategory7Alpha4: ColorChartCategory7Alpha4,
	ColorChartCategory8Alpha1: ColorChartCategory8Alpha1,
	ColorChartCategory8Alpha2: ColorChartCategory8Alpha2,
	ColorChartCategory8Alpha4: ColorChartCategory8Alpha4,
	ColorChartUncategory1: ColorChartUncategory1,
	ColorChartUncategory2: ColorChartUncategory2,
	ColorChartUncategory3: ColorChartUncategory3,
	ColorGrayPrimary: ColorGrayPrimary,
	ColorGrayPrimaryAlpha1: ColorGrayPrimaryAlpha1,
	ColorGrayPrimaryAlpha2: ColorGrayPrimaryAlpha2,
	ColorGrayPrimaryAlpha4: ColorGrayPrimaryAlpha4,
	ColorGraySecondary: ColorGraySecondary,
	ColorGraySecondaryAlpha1: ColorGraySecondaryAlpha1,
	ColorGraySecondaryAlpha2: ColorGraySecondaryAlpha2,
	ColorGraySecondaryAlpha4: ColorGraySecondaryAlpha4,
	ColorGrayIncidental: ColorGrayIncidental,
	ColorGrayIncidentalAlpha1: ColorGrayIncidentalAlpha1,
	ColorGrayIncidentalAlpha2: ColorGrayIncidentalAlpha2,
	ColorGrayIncidentalAlpha4: ColorGrayIncidentalAlpha4,
	ColorNotificationInfo: ColorNotificationInfo,
	ColorNotificationSuccess: ColorNotificationSuccess,
	ColorNotificationSuccessAlpha1: ColorNotificationSuccessAlpha1,
	ColorNotificationSuccessAlpha4: ColorNotificationSuccessAlpha4,
	ColorNotificationWarning: ColorNotificationWarning,
	ColorNotificationWarningAlpha1: ColorNotificationWarningAlpha1,
	ColorNotificationWarningAlpha4: ColorNotificationWarningAlpha4,
	ColorNotificationError: ColorNotificationError,
	ColorNotificationErrorAlpha1: ColorNotificationErrorAlpha1,
	ColorNotificationErrorAlpha4: ColorNotificationErrorAlpha4,
	ColorPrimaryBlue: ColorPrimaryBlue,
	ColorPrimaryBlueAlpha1: ColorPrimaryBlueAlpha1,
	ColorPrimaryBlueAlpha4: ColorPrimaryBlueAlpha4,
	ColorPrimaryBlueInteractive: ColorPrimaryBlueInteractive,
	ColorPrimaryBlueInteractiveAlpha1: ColorPrimaryBlueInteractiveAlpha1,
	ColorPrimaryBlueInteractiveAlpha2: ColorPrimaryBlueInteractiveAlpha2,
	ColorPrimaryBlueInteractiveAlpha4: ColorPrimaryBlueInteractiveAlpha4,
	ColorScaleLow: ColorScaleLow,
	ColorScaleMild: ColorScaleMild,
	ColorScaleModerate: ColorScaleModerate,
	ColorScaleElevated: ColorScaleElevated,
	ColorScaleHigh: ColorScaleHigh,
	ColorScaleSevere: ColorScaleSevere,
	ColorSecondaryBlueLight: ColorSecondaryBlueLight,
	ColorSecondaryBlueBrandLight: ColorSecondaryBlueBrandLight,
	ColorSecondaryPurpleLight: ColorSecondaryPurpleLight,
	ColorSecondaryPurpleLightAlpha1: ColorSecondaryPurpleLightAlpha1,
	ColorSecondaryPurpleDark: ColorSecondaryPurpleDark,
	ColorSecondaryPurpleDarkAlpha1: ColorSecondaryPurpleDarkAlpha1,
	ColorSecondaryVioletLight: ColorSecondaryVioletLight,
	ColorSecondaryVioletDark: ColorSecondaryVioletDark,
	ColorSecondaryVioletDarkAlpha1: ColorSecondaryVioletDarkAlpha1,
	ColorSecondaryTealLight: ColorSecondaryTealLight,
	ColorSecondaryTealDark: ColorSecondaryTealDark,
	ColorSecondaryTealDarkAlpha1: ColorSecondaryTealDarkAlpha1,
	ColorSecondaryPinkLight: ColorSecondaryPinkLight,
	ColorSecondaryPinkDark: ColorSecondaryPinkDark,
	ColorSecondaryPinkDarkAlpha1: ColorSecondaryPinkDarkAlpha1
};

var BreakpointDesktopSmall = "897px";
var BreakpointTabletPortrait = "896px";
var BreakpointMobilePortrait = "600px";
var BreakpointMd = "600px";
var BreakpointLg = "1200px";
var BreakpointXl = "1800px";
var TokenMediaQueries = {
	BreakpointDesktopSmall: BreakpointDesktopSmall,
	BreakpointTabletPortrait: BreakpointTabletPortrait,
	BreakpointMobilePortrait: BreakpointMobilePortrait,
	BreakpointMd: BreakpointMd,
	BreakpointLg: BreakpointLg,
	BreakpointXl: BreakpointXl
};

var SizingBaseUnit = "8px";
var SizingBorder = "1px";
var SizingBorderThick = "2px";
var SizingBorderRadius = "3px";
var SizingBorderRadiusDefault = "4px";
var SizingBorderRadiusTop = "4px 4px 0 0";
var SizingInputBoxShadowHOffset = "0";
var SizingInputBoxShadowVOffset = "0.2rem";
var SizingInputBoxShadowBlur = "0.4rem";
var SizingNone = "0";
var SizingSmall = "0.8rem";
var SizingMedium = "1.6rem";
var SizingLarge = "2.4rem";
var SizingXLarge = "3.2rem";
var SizingXxLarge = "4.0rem";
var SizingXxxLarge = "4.8rem";
var SizingXxxxLarge = "6.4rem";
var SizingComponentXLarge = "52px";
var SizingComponentLarge = "48px";
var SizingComponentDefault = "44px";
var SizingComponentCompact = "36px";
var SizingComponentSmall = "32px";
var SizingComponentXSmall = "24px";
var SizingComponentXxSmall = "16px";
var SizingFontInputFileHidden = "5rem";
var SizingHeightMini = "2.4rem";
var SizingHeightSmall = "3.2rem";
var SizingHeightMedium = "4.0rem";
var SizingHeightLarge = "4.8rem";
var SizingHeightFull = "100%";
var SizingHeightXxLarge = "4.2rem";
var SizingHeightXMini = "1.7rem";
var SizingHeightTab = "5.2rem";
var SizingWidthInputMini = "21.3rem";
var SizingWidthInputSmall = "25.7rem";
var SizingWidthInputMedium = "28.8rem";
var SizingWidthInputLarge = "44.7rem";
var SizingWidthButtonSmall = "5.6rem";
var SizingWidthButtonMedium = "20rem";
var SizingWidthButtonLarge = "28.8rem";
var SizingWidthModal = "63.2rem";
var TokenSizing = {
	SizingBaseUnit: SizingBaseUnit,
	SizingBorder: SizingBorder,
	SizingBorderThick: SizingBorderThick,
	SizingBorderRadius: SizingBorderRadius,
	SizingBorderRadiusDefault: SizingBorderRadiusDefault,
	SizingBorderRadiusTop: SizingBorderRadiusTop,
	SizingInputBoxShadowHOffset: SizingInputBoxShadowHOffset,
	SizingInputBoxShadowVOffset: SizingInputBoxShadowVOffset,
	SizingInputBoxShadowBlur: SizingInputBoxShadowBlur,
	SizingNone: SizingNone,
	SizingSmall: SizingSmall,
	SizingMedium: SizingMedium,
	SizingLarge: SizingLarge,
	SizingXLarge: SizingXLarge,
	SizingXxLarge: SizingXxLarge,
	SizingXxxLarge: SizingXxxLarge,
	SizingXxxxLarge: SizingXxxxLarge,
	SizingComponentXLarge: SizingComponentXLarge,
	SizingComponentLarge: SizingComponentLarge,
	SizingComponentDefault: SizingComponentDefault,
	SizingComponentCompact: SizingComponentCompact,
	SizingComponentSmall: SizingComponentSmall,
	SizingComponentXSmall: SizingComponentXSmall,
	SizingComponentXxSmall: SizingComponentXxSmall,
	SizingFontInputFileHidden: SizingFontInputFileHidden,
	SizingHeightMini: SizingHeightMini,
	SizingHeightSmall: SizingHeightSmall,
	SizingHeightMedium: SizingHeightMedium,
	SizingHeightLarge: SizingHeightLarge,
	SizingHeightFull: SizingHeightFull,
	SizingHeightXxLarge: SizingHeightXxLarge,
	SizingHeightXMini: SizingHeightXMini,
	SizingHeightTab: SizingHeightTab,
	SizingWidthInputMini: SizingWidthInputMini,
	SizingWidthInputSmall: SizingWidthInputSmall,
	SizingWidthInputMedium: SizingWidthInputMedium,
	SizingWidthInputLarge: SizingWidthInputLarge,
	SizingWidthButtonSmall: SizingWidthButtonSmall,
	SizingWidthButtonMedium: SizingWidthButtonMedium,
	SizingWidthButtonLarge: SizingWidthButtonLarge,
	SizingWidthModal: SizingWidthModal
};

var Spacing0 = "0";
var Spacing1 = ".4rem";
var Spacing2 = ".8rem";
var Spacing3 = "1.2rem";
var Spacing4 = "1.6rem";
var Spacing5 = "2.0rem";
var Spacing6 = "2.4rem";
var Spacing7 = "2.8rem";
var Spacing8 = "3.2rem";
var Spacing9 = "3.6rem";
var Spacing10 = "4.0rem";
var Spacing11 = "4.4rem";
var Spacing12 = "4.8rem";
var Spacing13 = "5.2rem";
var Spacing14 = "5.6rem";
var Spacing15 = "6.0rem";
var Spacing16 = "6.4rem";
var Spacing17 = "6.8rem";
var Spacing18 = "7.2rem";
var Spacing19 = "7.6rem";
var Spacing20 = "8.0rem";
var TokenSpacing = {
	Spacing0: Spacing0,
	Spacing1: Spacing1,
	Spacing2: Spacing2,
	Spacing3: Spacing3,
	Spacing4: Spacing4,
	Spacing5: Spacing5,
	Spacing6: Spacing6,
	Spacing7: Spacing7,
	Spacing8: Spacing8,
	Spacing9: Spacing9,
	Spacing10: Spacing10,
	Spacing11: Spacing11,
	Spacing12: Spacing12,
	Spacing13: Spacing13,
	Spacing14: Spacing14,
	Spacing15: Spacing15,
	Spacing16: Spacing16,
	Spacing17: Spacing17,
	Spacing18: Spacing18,
	Spacing19: Spacing19,
	Spacing20: Spacing20
};

var FontFamilySansSerif = "Avenir";
var FontFamilySerif = "serif";
var FontWeightAvenirLight = "350";
var FontWeightAvenirRoman = "550";
var FontWeightAvenirMedium = "650";
var FontWeightAvenirHeavy = "850";
var FontSizeHeadline1 = "5.6rem";
var FontSizeHeadline2 = "4.8rem";
var FontSizeHeadline3 = "4.0rem";
var FontSizeHeadline4 = "3.2rem";
var FontSizeHeadline5 = "2.4rem";
var FontSizeHeadline6 = "2.0rem";
var FontSizeSubtitle1 = "1.8rem";
var FontSizeSubtitle2 = "1.6rem";
var FontSizeBody = "1.6rem";
var FontSizeCompact = "1.4rem";
var FontSizeCaption = "1.2rem";
var FontSizeOverline = "1.2rem";
var FontLineHeightHeadline1 = "7.2rem";
var FontLineHeightHeadline2 = "6.4rem";
var FontLineHeightHeadline3 = "5.2rem";
var FontLineHeightHeadline4 = "4.4rem";
var FontLineHeightHeadline5 = "3.6rem";
var FontLineHeightHeadline6 = "3.2rem";
var FontLineHeightSubtitle1 = "2.4rem";
var FontLineHeightSubtitle2 = "2.4rem";
var FontLineHeightBody = "2.4rem";
var FontLineHeightCompact = "2.0rem";
var FontLineHeightCaption = "1.6rem";
var FontLineHeightOverline = "1.6rem";
var FontLetterSpacingHeadline1 = "normal";
var FontLetterSpacingHeadline2 = "normal";
var FontLetterSpacingHeadline3 = "normal";
var FontLetterSpacingHeadline4 = "normal";
var FontLetterSpacingHeadline5 = "normal";
var FontLetterSpacingHeadline6 = "normal";
var FontLetterSpacingSubtitle1 = "0.015rem";
var FontLetterSpacingSubtitle2 = "0.01rem";
var FontLetterSpacingBody = "0.01rem";
var FontLetterSpacingCompact = "0.01rem";
var FontLetterSpacingCaption = "0.02rem";
var FontLetterSpacingOverline = "0.1rem";
var FontTextTransformUppercase = "uppercase";
var FontParagraphHeadline1 = "4.0rem";
var FontParagraphHeadline2 = "3.6rem";
var FontParagraphHeadline3 = "3.2rem";
var FontParagraphHeadline4 = "3.2rem";
var FontParagraphHeadline5 = "2.8rem";
var FontParagraphHeadline6 = "2.4rem";
var FontParagraphSubtitle1 = "2.4rem";
var FontParagraphSubtitle2 = "2.0rem";
var FontParagraphBody = "2.0rem";
var FontParagraphCompact = "1.6rem";
var FontParagraphCaption = "1.2rem";
var FontParagraphOverline = "1.2rem";
var TokenTypography = {
	FontFamilySansSerif: FontFamilySansSerif,
	FontFamilySerif: FontFamilySerif,
	FontWeightAvenirLight: FontWeightAvenirLight,
	FontWeightAvenirRoman: FontWeightAvenirRoman,
	FontWeightAvenirMedium: FontWeightAvenirMedium,
	FontWeightAvenirHeavy: FontWeightAvenirHeavy,
	FontSizeHeadline1: FontSizeHeadline1,
	FontSizeHeadline2: FontSizeHeadline2,
	FontSizeHeadline3: FontSizeHeadline3,
	FontSizeHeadline4: FontSizeHeadline4,
	FontSizeHeadline5: FontSizeHeadline5,
	FontSizeHeadline6: FontSizeHeadline6,
	FontSizeSubtitle1: FontSizeSubtitle1,
	FontSizeSubtitle2: FontSizeSubtitle2,
	FontSizeBody: FontSizeBody,
	FontSizeCompact: FontSizeCompact,
	FontSizeCaption: FontSizeCaption,
	FontSizeOverline: FontSizeOverline,
	FontLineHeightHeadline1: FontLineHeightHeadline1,
	FontLineHeightHeadline2: FontLineHeightHeadline2,
	FontLineHeightHeadline3: FontLineHeightHeadline3,
	FontLineHeightHeadline4: FontLineHeightHeadline4,
	FontLineHeightHeadline5: FontLineHeightHeadline5,
	FontLineHeightHeadline6: FontLineHeightHeadline6,
	FontLineHeightSubtitle1: FontLineHeightSubtitle1,
	FontLineHeightSubtitle2: FontLineHeightSubtitle2,
	FontLineHeightBody: FontLineHeightBody,
	FontLineHeightCompact: FontLineHeightCompact,
	FontLineHeightCaption: FontLineHeightCaption,
	FontLineHeightOverline: FontLineHeightOverline,
	FontLetterSpacingHeadline1: FontLetterSpacingHeadline1,
	FontLetterSpacingHeadline2: FontLetterSpacingHeadline2,
	FontLetterSpacingHeadline3: FontLetterSpacingHeadline3,
	FontLetterSpacingHeadline4: FontLetterSpacingHeadline4,
	FontLetterSpacingHeadline5: FontLetterSpacingHeadline5,
	FontLetterSpacingHeadline6: FontLetterSpacingHeadline6,
	FontLetterSpacingSubtitle1: FontLetterSpacingSubtitle1,
	FontLetterSpacingSubtitle2: FontLetterSpacingSubtitle2,
	FontLetterSpacingBody: FontLetterSpacingBody,
	FontLetterSpacingCompact: FontLetterSpacingCompact,
	FontLetterSpacingCaption: FontLetterSpacingCaption,
	FontLetterSpacingOverline: FontLetterSpacingOverline,
	FontTextTransformUppercase: FontTextTransformUppercase,
	FontParagraphHeadline1: FontParagraphHeadline1,
	FontParagraphHeadline2: FontParagraphHeadline2,
	FontParagraphHeadline3: FontParagraphHeadline3,
	FontParagraphHeadline4: FontParagraphHeadline4,
	FontParagraphHeadline5: FontParagraphHeadline5,
	FontParagraphHeadline6: FontParagraphHeadline6,
	FontParagraphSubtitle1: FontParagraphSubtitle1,
	FontParagraphSubtitle2: FontParagraphSubtitle2,
	FontParagraphBody: FontParagraphBody,
	FontParagraphCompact: FontParagraphCompact,
	FontParagraphCaption: FontParagraphCaption,
	FontParagraphOverline: FontParagraphOverline
};

var index = {
    TokenChartColors: TokenChartColors,
    TokenColors: TokenColors,
    TokenMediaQueries: TokenMediaQueries,
    TokenSizing: TokenSizing,
    TokenSpacing: TokenSpacing,
    TokenTypography: TokenTypography,
    TokenBorders: TokenBorders,
    TokenShadows: TokenShadows,
    TokenOpacity: TokenOpacity
};

export { index as default };
//# sourceMappingURL=index.es.js.map
